import { router, useLocalSearchParams } from "expo-router";
import { useCallback } from "react";
import { useAilaStore } from "./useAilaStore";

/**
 * Leaves review mode: back to wherever review was entered from, or the session
 * report when there is no history to pop.
 */
const useExitReview = () => {
	const { id } = useLocalSearchParams<{ id: string }>();
	const updateShowDrawer = useAilaStore((s) => s.updateShowDrawer);

	return useCallback(() => {
		updateShowDrawer(false);
		if (router.canGoBack()) {
			router.back();
		} else {
			router.replace({
				pathname: "/(protected)/session/[id]/report",
				params: { id },
			});
		}
	}, [updateShowDrawer, id]);
};

export default useExitReview;
